import React, { forwardRef, useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage, FormikProps } from 'formik';
import * as yup from 'yup';

// Définir le type pour les données du formulaire
export type ScenarioProps = 'scenario1' | 'scenario2' | 'scenarioPerso' | '';

export type CancelFormData = {
    cancelledReason: string | undefined;
};

export type CancelFormProps = {
    initialValues: CancelFormData;
    onSubmit: (values: CancelFormData) => void;
    onClose: () => void;
};

export const CancelFormSchema = yup.object().shape({
    cancelledReason: yup.string().required('Veuillez sélectionner un scénario.'),
});

export const DEFAULT_REASON_1 = 'Le client ne souhaite plus faire de rénovation';
export const DEFAULT_REASON_2 = "Le client n'a pas obtenu de financement";
export const DEFAULT_REASON_PERSO_LABEL = 'Pour une autre raison (merci de compléter) : ';
export const DEFAULT_REASON_PERSO = "Le client n'a pas souhaité poursuivre la rénovation";

const CancelForm = forwardRef<FormikProps<CancelFormData>, CancelFormProps>((props: CancelFormProps, ref) => {
    const [selectedReason, setSelectedReason] = useState<ScenarioProps>('');
    const [reasons, setReasons] = useState<{ value: ScenarioProps; label: string; comment: string }[]>([]);

    useEffect(() => {
        setReasons([
            {
                value: 'scenario1',
                label: DEFAULT_REASON_1,
                comment: DEFAULT_REASON_1,
            },
            {
                value: 'scenario2',
                label: DEFAULT_REASON_2,
                comment: DEFAULT_REASON_2,
            },
            {
                value: 'scenarioPerso',
                label: DEFAULT_REASON_PERSO_LABEL,
                comment: DEFAULT_REASON_PERSO,
            },
        ]);
    }, []);

    return (
        <div>
            <p>Sélectionnez un commentaire à destination de l'accompagnateur Rénov'</p>
            <Formik
                initialValues={{
                    cancelledReason: props.initialValues.cancelledReason,
                }}
                validationSchema={CancelFormSchema}
                onSubmit={props.onSubmit}
                innerRef={ref}
                validateOnMount
                validateOnChange
            >
                {({ values, setValues, isValid }) => (
                    <Form className="container">
                        <div className="row">
                            {reasons.map((reason, index) => (
                                <div className="col-12" key={index}>
                                    <div className="form-group">
                                        <div className="custom-radio">
                                            <Field
                                                type="radio"
                                                id={reason.value}
                                                value={reason.value}
                                                name="reason"
                                                checked={selectedReason === reason.value}
                                                onChange={() => {
                                                    setSelectedReason(reason.value);
                                                    setValues({
                                                        cancelledReason: reason.comment,
                                                    });
                                                }}
                                            />
                                            <div className="fake-radio">{/* Leave empty */}</div>
                                            <label htmlFor={reason.value}>{reason.label}</label>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="position-relative">
                            <Field
                                as="textarea"
                                name="scenarioPersoText"
                                placeholder="Entrez votre scénario personnalisé"
                                disabled={selectedReason !== 'scenarioPerso'}
                                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                    setSelectedReason('scenarioPerso');
                                    const newScenarioPersoText = e.target.value;
                                    setValues({
                                        cancelledReason: newScenarioPersoText,
                                    });
                                    // Mettre à jour le scénario personnalisé
                                    setReasons((prevReasons) =>
                                        prevReasons.map((reason) => (reason.value === 'scenarioPerso' ? { ...reason, comment: newScenarioPersoText } : reason))
                                    );
                                }}
                                className="form-control"
                                value={selectedReason === 'scenarioPerso' ? values.cancelledReason?.replace(DEFAULT_REASON_PERSO, '') : ''}
                            />

                            <ErrorMessage name="scenarioPersoText" component="span" className="invalid-feedback " />
                        </div>
                        <div className="btn-grp justify-content-center mt-5">
                            <button type="button" className="btn btn-retour min-width" onClick={props.onClose}>
                                Annuler
                            </button>
                            <button type="submit" className="btn btn-continue min-width" disabled={!isValid}>
                                Envoyer
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
});
export default CancelForm;
